// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_online-task-inspection_thanks_thanks_module_ts":"6651a8a10e4905d4a6db","src_app_error_forbidden_forbidden_module_ts":"8b80225565fb2ef2300f","src_app_error_not-found_not-found_module_ts":"bc6600084a3010cb369c"}[chunkId] + ".js";
};